export function transformDateSelectionJoin(hit0, hit1) {
    var resourceId0 = hit0.dateSpan.resourceId;
    var resourceId1 = hit1.dateSpan.resourceId;
    if (resourceId0 && resourceId1) {
        if (hit0.component.allowAcrossResources === false &&
            resourceId0 !== resourceId1) {
            return false;
        }
        else {
            return { resourceId: resourceId0 };
        }
    }
}
